// /* global window, document */
// if (! window._babelPolyfill) {
//   require('@babel/polyfill');
// }

import React from "react";
import ReactDOM from "react-dom";
import "../common/shared.scss"
import BuyButton from "../components/BuyButton/BuyButton.jsx";
import Provider, { Context } from "../store/Provider.js";
document.addEventListener("DOMContentLoaded", function() {
  const shortcode_containers = document.querySelectorAll(
    ".ms-resamania-buy-button"
  );

  for (let i = 0; i < shortcode_containers.length; ++i) {
    const objectId = shortcode_containers[i].getAttribute("data-object-id");

    ReactDOM.render(
      <Provider>
        <Context.Consumer>
          {store => <BuyButton wpObject={window[objectId]} store={store} />}
        </Context.Consumer>
      </Provider>,
      shortcode_containers[i]
    );
  }
});
